<template>
  <form-section id="product_and_area" :headline="this.$t('form.product_and_area.legend')">
    <append-list
      id="products"
      :label="this.$t('form.product_and_area.products.label')"
      :placeholder="this.$t('form.product_and_area.products.placeholder')"
      v-model="productsAndArea.products"
      :errorMessage="this.$t('form.shared.validation_error')"
      :addButtonLabel="this.$t('form.product_and_area.products.add_button_label')"
      :removeButtonLabel="this.$t('form.shared.remove_button_label')"
    />

    <textfield
      id="area"
      :label="this.$t('form.product_and_area.areas.label')"
      :placeholder="this.$t('form.product_and_area.areas.placeholder')"
      v-model="productsAndArea.areas"
      :errorMessage="this.$t('form.shared.validation_error')"
    />

    <checkbox
      id="has-exclusive-right"
      :label="this.$t('form.product_and_area.exclusive_right.label')"
      v-model="productsAndArea.hasExclusiveRight"
    />
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import AppendList from "@/shared/components/AppendList.vue";
import Textfield from "@/shared/components/Textfield";
import Checkbox from "@/shared/components/Checkbox";

export default {
  components: {
    FormSection,
    AppendList,
    Textfield,
    Checkbox
  },
  data() {
    return {
      productsAndArea: {
        products: [],
        areas: "",
        hasExclusiveRight: false
      }
    };
  },
  watch: {
    productsAndArea: {
      handler() {
        this.$store.commit("updateProductsAndArea", this.productsAndArea);
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/ProductsAndAreaInput.vue